import SearchList from './SearchList';
import UnauthorisedPage from "../components/UnauthorisedPage";

export default {
    list: SearchList,
    unauthorised: UnauthorisedPage
};
